import { HeadCell } from "../../components/common/SortableTableHead";

export const COLUMN_HEADERS: HeadCell[] = [
    { label: "Hardware Source", property: "hardwareSource", sortable: true },
    { label: "Capture Id", property: "captureId", sortable: false },
    { label: "ASIN", property: "asin", sortable: false},
    { label: "FNSKU", property: "fnsku", sortable: false },
    { label: "FCSKU", property: "fcsku", sortable: false },
    { label: "Warehouse Id", property: "warehouseId", sortable: true },
    { label: "Bin Id", property: "binId", sortable: false },
    { label: "Capture Timestamp", property: "captureTimestamp", sortable: true },
    { label: "Is Complete Capture", property: "isCompleteCapture", sortable: true },
];

export const INITIAL_MESSAGE: string = "Please search for an item to view results";

export const ERROR_MESSAGE: string = "Something went wrong while retrieving captures for requested item";

export const EMPTY_RESULTS_MESSAGE: string = "No captures available for requested item in Item Matrix repository";
